import React from "react";
import UploadBox from "../UploadBox";


const FileUploadBox = ({title}) => {
    return (
        <div className="mb-4">
            <p className="fs-6 mb-2 fw-semibold">{title}</p>
            <UploadBox
                label="Upload"
                subtext="Max 20mb pdf"
                padding="p-3"
            />
        </div>
    );
};

export default FileUploadBox;